import { PATH } from 'src/constants/Path';
import { useDomainEnv } from 'src/hooks';
import MenuItem from './MenuItem/MenuItem';

const DevConfigMenuItem = () => {
  const { isDomainProdEnv } = useDomainEnv();

  return (
    <>
      {!isDomainProdEnv && (
        <MenuItem
          title={'pageTitle_devConfig'}
          path={PATH.devConfig}
          analyticEvent="dev_config"
        />
      )}
    </>
  );
};

export default DevConfigMenuItem;
